import React, { useEffect, useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/free-solid-svg-icons'

import './Title.css'

interface TitleProps {
	children: React.ReactNode
	editable?: boolean
	value?: string
	onChange?: (value: string) => void
	placeholder?: string
}

function Title(props: TitleProps) {
	const [isEditing, setIsEditing] = useState(false)
	const [internalValue, setInternalValue] = useState(() => {
		if (typeof props.value === 'string') {
			return props.value
		}
		if (typeof props.children === 'string') {
			return props.children
		}
		return ''
	})

	useEffect(() => {
		if (typeof props.value === 'string') {
			setInternalValue(props.value)
		}
	}, [props.value])

	const currentValue = typeof props.value === 'string' ? props.value : internalValue

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const nextValue = event.target.value
		if (props.onChange) {
			props.onChange(nextValue)
		}
		if (props.value === undefined) {
			setInternalValue(nextValue)
		}
	}

	const handleStopEditing = () => {
		setIsEditing(false)
	}

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter' || event.key === 'Escape') {
			event.preventDefault()
			handleStopEditing()
		}
	}

	const renderTitle = () => <h2 className='title'>{props.children}</h2>

	const renderEditable = () => (
		<div id='titleContainer'>
			{isEditing ? (
				<input
					className='titleInput'
					type='text'
					value={currentValue}
					placeholder={props.placeholder}
					onChange={handleInputChange}
					onBlur={handleStopEditing}
					onKeyDown={handleKeyDown}
					autoFocus
				/>
			) : (
				<h2
					className='title titleUnderline titleEditable'
					onClick={() => setIsEditing(true)}
				>
					{currentValue || props.placeholder || props.children}
				</h2>
			)}
			<button
				className='titleEditButton'
				type='button'
				onClick={() => setIsEditing(true)}
				aria-label='Edit title'
			>
				<FontAwesomeIcon icon={faPencil} />
			</button>
		</div>
	)

	if (props.editable === true) {
		return renderEditable()
	} else {
		return renderTitle()
	}
}

export default Title
